export default function Content(props) {
  return(
    <div className="app__content">
      {props.children}
    </div>
  );
}
